function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M89.999 0H0V59.9981H89.999V0Z",
  fill: "#F0F0F0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.999 0H0V60H29.999V0Z",
  fill: "#D80027"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M89.999 0H60V60H89.999V0Z",
  fill: "#D80027"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M50.6243 34.1668L56.2493 31.3544L53.4368 29.9483V27.1358L47.8119 29.9483L50.6243 24.3234H47.8119L44.9994 20.1045L42.1869 24.3234H39.3745L42.1869 29.9483L36.562 27.1358V29.9483L33.7495 31.3544L39.3745 34.1668L37.9684 36.9793H43.5933V41.1982H46.4058V36.9793H52.0307L50.6243 34.1668Z",
  fill: "#D80027"
});

var SvgCad = function SvgCad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CAD.3f639fe6.svg";
export { ForwardRef as ReactComponent };